module.exports = __webpack_public_path__ + "img/邮箱配置.14ae1222.svg";